import { render, staticRenderFns } from "./inquiry-tab.vue?vue&type=template&id=044c849d&"
import script from "./inquiry-tab.vue?vue&type=script&lang=js&"
export * from "./inquiry-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports